import { render, staticRenderFns } from "./HandlingDaysUpload.vue?vue&type=template&id=83524086&"
import script from "./HandlingDaysUpload.vue?vue&type=script&lang=js&"
export * from "./HandlingDaysUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports